export const userUrl = {
  userInfo: 'www/user.php',
  smrzInfo: 'www/smrz.php',
}
export const passwordUrl = {
  sendCode: 'www/user.php',
}
export const caiwuUrl = {
  caiwuInfo: 'www/caiwu.php'
}
export const beianUrl = {
  beianInfo:'www/beian.php',
  beianZt:'admin/beian.php',
  beianCode:'www/beian.php?cmd=img_yzm',
  beianKuaidi:'www/beian_kd.php',
  beianMain:'www/mianbeian.php'
}
export const domainUrl = {
  domainInfo: 'www/domain.php'
}
export const vhostUrl = {
  vhostInfo: 'www/vhost.php'
}
export const vpsUrl = {
  vpsInfo: 'www/vps.php',
  vpsBuyInfo: 'www/vps_buy.php'
}
export const helpUrl = {
  helpInfo: 'www/help.php'
}
export const gdUrl = {
  gdInfo: 'www/gd.php'
}
export const bmdUrl = {
  bmdInfo: 'www/bmd.php'
}
export const loginUrl = {
  loginInfo: 'www/login.php?cmd=logout'
}
export const renewUrl = {
  renewInfo: 'www/renew.php'
}
export const upgradeUrl = {
  upgradeInfo: 'www/upgrade.php'
}
export const payUrl = {
  payInfo: 'autopay/pay.php'
}



// WEBPACK FOOTER //
// ./src/config/urlConfig.js